module.exports = __webpack_public_path__ + "media/images/university_logos/Newcastle-University-f02f39b364fd8a52fe93429ea75a7242.svg";